import React from "react";
import { cn } from "../../lib/utils";
import { CheckIcon } from "lucide-react";

export const Card = ({ className, active, children, ...props }) => (
  <div
    className={cn(
      "rounded-2xl border bg-card text-card-foreground bg-background group overflow-hidden relative",
      active && "ring-2 ring-primary ring-offset-2 ring-offset-background",
      className
    )}
    {...props}
  >
    {children}

    {active && (
      <div className="top-3 right-3 absolute size-5 bg-primary rounded-full flex items-center justify-center">
        <CheckIcon className="text-white size-4" />
      </div>
    )}
  </div>
);

export const CardImage = ({ className, alt, ...props }) => (
  <div className={cn("overflow-hidden w-full h-[200px]", className)}>
    <img
      alt={alt || "Card image"}
      className={"h-full w-full object-cover transition-all"}
      {...props}
    />
  </div>
);

export const CardContent = ({ className, ...props }) => (
  <div className={cn("px-4 py-3", className)} {...props} />
);

export default Card;
